import { Seo } from "@/components/Seo";
import { Reveal, PillButton, Hairline, StatusBadge } from "@/components/primitives";
import { StrategicAssetsNav } from "@/components/StrategicAssetsNav";

const SECTIONS = [
  { t: "Tax & Financial Intelligence", d: "Derived tax and financial intelligence that supports informed decisions. This is the capability that has actually been built." },
  { t: "Tax Optimization Technology", d: "A tax-intelligence and optimization platform that analyzes a complete tax position and tests competing treatments. Explore it under Tax Optimization." },
];

const FUTURE = [
  "Asset & opportunity research across distressed and overlooked positions",
  "Mispricing and surplus signal analysis",
  "Broader portfolio and asset-class intelligence",
];

export default function SAIntelligence() {
  return (
    <div className="glow-navy min-h-screen">
      <Seo title="Strategic Assets Intelligence — Strategic Assets" description="Strategic Assets Intelligence — tax and financial intelligence supporting informed decisions. Current capability is limited to the tax-intelligence technology that has been built; broader asset and opportunity research is in development." />
      <StrategicAssetsNav />

      <section className="pt-12 md:pt-16 pb-6 px-6 text-center">
        <Reveal>
          <StatusBadge status="Current platform capability" className="mb-5" />
          <h1 className="font-serif2 text-4xl md:text-5xl text-[var(--bone)] leading-tight">Strategic Assets Intelligence</h1>
          <p className="mt-6 max-w-2xl mx-auto text-lg md:text-xl text-[var(--bone)]/85 leading-relaxed">
            Convert fragmented financial, tax, entity, ownership, and asset information into a documented view of what is known, what remains uncertain, and what requires action. Our current capability is limited to the tax-intelligence technology that has actually been built.
          </p>
        </Reveal>
      </section>

      <section className="py-10 px-6">
        <div className="max-w-4xl mx-auto">
          <Reveal><Hairline className="opacity-70 mb-12" /></Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-10">
            {SECTIONS.map((s, i) => (
              <Reveal key={s.t} delay={i * 0.05}>
                <div className="corner-frame px-7 py-8 h-full">
                  <h3 className="font-serif2 text-xl md:text-2xl text-[var(--bone)]">{s.t}</h3>
                  <p className="mt-4 text-sm md:text-base text-[var(--bone)]/75 leading-relaxed">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1} className="mt-12">
            <div className="corner-frame px-7 py-8">
              <div className="flex items-center gap-4 flex-wrap">
                <StatusBadge status="In development" />
                <h3 className="font-serif2 text-lg md:text-xl text-[var(--bone)]">Broader Asset & Opportunity Research</h3>
              </div>
              <ul className="mt-5 space-y-3">
                {FUTURE.map((f) => (
                  <li key={f} className="flex gap-3 text-sm md:text-base text-[var(--bone)]/70 leading-relaxed">
                    <span className="text-[var(--gold)] mt-0.5">•</span>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-5 font-display uppercase tracking-wide2 text-[10px] text-[var(--muted)] leading-relaxed">
                These capabilities are in development and are not yet operational.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.15} className="mt-12 text-center">
            <PillButton to="/strategic-assets/tax-optimization" testid="sa-intel-tax">Explore Tax Optimization</PillButton>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
